// extracted by mini-css-extract-plugin
module.exports = {"commentList":"_1-iCi","separator":"_2XHNt"};